import {ExamModuleDb, getExamModuleCollectionPath} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getExamModulesCollection(): CollectionReference<ExamModuleDb> {
  return collection(firebaseFirestore, getExamModuleCollectionPath()) as CollectionReference<ExamModuleDb>;
}
